type PillTone = 'neutral' | 'positive' | 'warning' | 'critical' | 'info';

const TONE_BY_STATUS: Record<string, PillTone> = {
  active: 'positive',
  open: 'positive',
  available: 'positive',
  provisioned: 'positive',
  online: 'positive',
  deprecated: 'warning',
  invited: 'warning',
  pending: 'warning',
  unknown: 'warning',
  suspended: 'critical',
  disabled: 'critical',
  destroyed: 'critical',
  faulty: 'critical',
  offline: 'critical',
  closed: 'neutral',
  reserved: 'info',
  assigned: 'info',
};

function toneFor(status: string): PillTone {
  return TONE_BY_STATUS[status.trim().toLowerCase()] ?? 'neutral';
}

interface StatusPillProps {
  status: string | null | undefined;
  empty?: string;
}

export function StatusPill({ status, empty = '—' }: StatusPillProps): JSX.Element {
  const value = (status ?? '').trim();
  if (!value) {
    return <span className="status-pill status-pill--neutral">{empty}</span>;
  }
  const tone = toneFor(value);
  return <span className={`status-pill status-pill--${tone}`}>{value}</span>;
}
